import polyglotI18nProvider from 'ra-i18n-polyglot';

import en from './locales/en.json';

import { TranslationMessages } from 'ra-core';

const locales: Record<string, TranslationMessages> = {
  en: en as unknown as TranslationMessages,
};
type Locale = keyof typeof locales;

const DEFAULT_LOCALE = 'en';
const AVAILABLE_LOCALES: Locale[] | any = [{ locale: 'en', name: 'English' }];

export const i18nProvider = polyglotI18nProvider(
  (locale: string) => locales[locale as Locale],
  DEFAULT_LOCALE,
  AVAILABLE_LOCALES,
  { allowMissing: true }
);
